
<template>
  <section class="common-redio" @click="handClick" :class="disabled ? 'redio-disbaled' : ''">
    <svg
      v-if="value"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <circle cx="7" cy="7" r="6" stroke="#2B61FF" stroke-width="2" />
      <circle cx="7" cy="7" r="4" fill="#2B61FF" />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      v-else
    >
      <circle cx="7" cy="7" r="6" stroke="#93979D" stroke-width="2" />
    </svg>
  </section>
</template>

<script>
export default {
  name: "v-redio",
  props: {
    value: { default: false, type: Boolean },
    name: { default: "", type: String },
    disabled: { default: false, type: Boolean },
    // className: { default:  }
  },
  methods: {
    handClick() {
      this.$emit("click", this.name);
    },
  },
};
</script>
<style lang="scss">
.common-redio {
  display: inline-block;
  cursor: pointer;
}
.redio-disbaled{
  cursor: not-allowed;
}
</style>
